import { atom } from 'nanostores';

/**
 * Holds the wake-up closure for a sleeping chat.
 * Set by useChatHistory when a chat opens without a running pod.
 * Consumed by SleepBanner on user click.
 */
export const $wakeUpFn = atom<(() => Promise<void>) | null>(null);

/**
 * True when a resume ran to completion without ever producing a preview.
 *
 * This exists so the Resume affordance can come back WITHOUT overloading
 * runtime.status. Writing 'sleeping' there instead looked equivalent but is
 * not: _markServing only promotes from 'starting', so a pod that was merely
 * slow — a cold dev server routinely outlasts the 15x1s poll budget — would
 * have its late :5173 event discarded and stay wedged until a page reload.
 * Keeping the two signals separate lets the runtime heal itself while the
 * banner still tells the user the attempt failed.
 */
export const $resumeFailed = atom<boolean>(false);

/**
 * True from Resume-click until the wake flow settles. Keeps the SleepBanner
 * (with its "Resuming…" spinner) mounted even though runtime.status leaves
 * 'sleeping' the moment boot() starts — otherwise the banner vanishes with
 * no loading feedback while the pod restores.
 */
export const $wakingUp = atom<boolean>(false);
